import { Button } from "../../../../../components/ui/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LuMails } from "react-icons/lu";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../../components/ui/dialog";
import { resendInvite } from "../../../../../helpers/api";
import { useState } from "react";

const ResendInviteModal = ({ data }) => {
  const [open, setOpen] = useState(false);

  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (email) => resendInvite(email), // wrap in object

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["team"],
      });
      toast("Email sent successfully");
      setOpen(false);
    },
    onError: (data) => {
      toast(data.message);
    },
  });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="w-fit px-2 rounded-lg bg-neutral200" variant="ghost">
          <LuMails size={16} />
          <span className="font-medium pr-2">Resend</span>
        </Button>
      </DialogTrigger>
      <DialogContent className="md:w-[400px]">
        <DialogHeader className="text-left">
          <DialogTitle className="text-md text-semibold text-black">
            Resend Invitation
          </DialogTitle>
          <DialogDescription className="text-black">
            Do you want to resend the invitation to <b>{data?.email}</b>?
            They will receive a fresh link to join Turingtower VM.
          </DialogDescription>
        </DialogHeader>
        <hr />
        <div className="flex justify-end space-x-4">
          <Button
            variant="outline"
            type="button" // prevents form submission
            className="px-4 py-2 font-medium bg-white text-black"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="px-4 py-2 font-medium text-white"
            loading={isPending}
            onClick={() => mutate({ email: data.email })}
          >
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ResendInviteModal;
